/*
 * @Author: likk
 * @Date: 2023-09-07 14:11:33
 * @LastEditTime: 2024-03-22 04:03:41
 * @LastEditors: likk 1126919170@qq.com
 * @Description: 供需信息相关接口
 */
import request from "@/utils/request";
import { base } from "@/api/base";
// 作业需求发布
export function workXuqiuIssue(params) {
  return request({
    url: `${base.request}/dispatch/coop/supply/workDemand/publish`,
    method: "post",
    data: params,
  });
}
// 作业服务发布
export function workServiceIssue(params) {
  return request({
    url: `${base.request}/dispatch/coop/supply/workServer/publish`,
    method: "post",
    data: params,
  });
}
 // 作业服务审核
export function workServiceAudit(params) {
  return request({
    url: `${base.request}/dudu/supply/workServer/audit`,
    method: "post",
    data: params,
  });
}
// 作业需求审核
export function workXuqiuAudit(params) {
  return request({
    url: `${base.request}/dudu/supply/workDemand/audit`,
    method: "post",
    data: params,
  });
}
// 作业需求信息列表
export function workXuqiuList(params) {
  return request({
    url: `${base.request}/dudu/supply/workDemand/list`,
    method: "get",
    params: params,
  });
}
// 作业需求信息详情
export function workXuqiuDetail(id) {
  return request({
    url: `${base.request}/dudu/supply/workDemand/detailById/${id}`,
    method: "get"
  });
}
// 作业需求数据修改
export function workDemandModify(params) {
  return request({
    url: `${base.request}/dudu/supply/workDemand/modify`,
    method: "post",
    data: params
  });
}

//作业服务信息列表
export function workServiceList(params) {
  return request({
    url: `${base.request}/dudu/supply/workServer/list`,
    method: "get",
    params: params,
  });
}
//作业服务信息详情
export function workServiceDetail(id) {
  return request({
    url: `${base.request}/dudu/supply/workServer/detailById/${id}`,
    method: "get"
  });
}
// 作业服务数据修改
export function workServiceModify(params) {
  return request({
    url: `${base.request}/dudu/supply/workServer/modify`,
    method: "post",
    data: params
  });
}
// 作业服务数据删除
export function workServiceDelete(id) {
  return request({
    url: `${base.request}/dudu/supply/workServer/del/${id}`,
    method: "get"
  });
}
// 作业服务数据删除
export function workDemandDelete(id) {
  return request({
    url: `${base.request}/dudu/supply/workDemand/del/${id}`,
    method: "get"
  });
}

// 获取作物类型
export function cropTree() {
  return request({
    url: `${base.request}/dudu/supply/workServer/cropTree`,
    method: "get"
  });
}
// 获取作业类型
export function workTypeTree() {
  return request({
    url: `${base.request}/dudu/supply/workServer/workTypeTree`,
    method: "get"
  });
}
// /作物二级ID获取作业类型接口
export function workTypeByCropId(params) {
  return request({
    url: `${base.request}/dudu/supply/workServer/getWorkTypeByCropId`,
    method: "get",
    params
  });
}
// 获取全部品牌名称接口
export function brandList() {
  return request({
    url: `${base.request}/dispatch/ddDispatchBasic/brandList`,
    method: "get"
  });
}
// 品牌名称联想
export function brandAssociate(params) {
  return request({
    url: `${base.request}/dudu/supply/workServer/getBrandAssociate`,
    method: "get",
    params
  });
}
//获取全部机具类型数据
export function machineTypeTree(){
  return request({
    url: `${base.request}/dudu/supply/workServer/getMachineTypeTree`,
    method: "get"
  });
}
// 企业名称联想
export function companyAssociate(params){
  return request({
    url: `${base.request}/dudu/supply/workServer/getCompanyAssociate`,
    method: "get",
    params
  });
}
// 根据企业id查询型号
export function modelByComId(params){
  return request({
    url: `${base.request}/dudu/supply/workServer/getModelByComId`,
    method: "get",
    params
  });
}
// 预约机手
export function reservationServer(params){
  return request({
    url:`${base.request}/dudu/supply/workDemand/reservation`,
    method:'post',
    data:params
  });
}
// 根据经纬度获取地址
export function geocoder(params) {
  return request({
    url: `${base.request}/dudu/supply/workServer/getGeocoder`,
    method: "get",
    params: params,
  });
}
 // 根据地区id获取地图中心点经纬度
export function getlatLngByRegionId(params){
  return request({
    url: `${base.request}/dudu/supply/workServer/getRegionLngLat`,
    method: "get",
    params
  });
}
//身份类型
export function getIdentityType(params){
  return request({
    url: `${base.request}/dudu/supply/workServer/identityType`,
    method: "get",
    params
  });
}
// 紧急程度 
export function getRequirementType(params){
  return request({
    url: `${base.request}/dudu/supply/workServer/requirementType`,
    method: "get",
    params
  });
}



